import * as types from './mutations-types';

export default {
    setLoaderStatus({state, commit, rootState}, status) {
        commit(types.SET_LOADER_STATUS, status);
    },
}